<div class="gallery" *ngIf="hasImages">
    <div class="main-image">
        <img [src]="selectedImageUrl" alt="" />
    </div>
    <div class="images">
        <ul>
            <li
                *ngFor="let imageUrl of images"
                [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')' }"
                [class.selected]="imageUrl === selectedImageUrl"
                (click)="changeSelectedImage(imageUrl)"
            ></li>
        </ul>
    </div>
</div>
